import React, { useState, useEffect } from 'react';
import {
  View,
  TextInput,
  Button,
  Text,
  Pressable,
  BackHandler,
  Platform,
  PermissionsAndroid,
} from 'react-native';
import Auth from '../../auth/AuthHelper';
import mystyles from '../../assets/styles/mystyles';
import Geolocation from 'react-native-geolocation-service';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {callApi} from '../Helper/Helper';
import {setCurrentZipCode} from '../Helper/Helper';


const ENDPOINT_URL = 'https://api.eabu.net';
// JavaScript
export default function SignInScreen({ navigation }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage]   = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [zipcode, setZipcode] = useState('');

  // Check for existing session when component mounts
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const current = await Auth.getCurrentUser();
        if (current) {
          navigation.replace('Home');
        }
      } catch (e) {
        // Silent fail - user needs to sign in
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [navigation]);

  const handleSubmit = async () => {
    const trimmedZipcode = zipcode.trim();

    if (!trimmedZipcode || trimmedZipcode.length < 5) {
      setMessage('Please enter a valid ZIP code.');
      return;
    }

    //save the zipcode in the loggedin session
    await setCurrentZipCode(zipcode);

  };

  const handleSignIn = async () => {
    try {
      const trimmedZipcode = zipcode.trim();
      if (!trimmedZipcode || trimmedZipcode.length < 5) {
        setMessage('Please enter a valid ZIP code.');
        return;
      }

      const result = await Auth.signIn({ username, password });

      if (result?.nextStep?.signInStep && result.nextStep.signInStep !== 'DONE') {
        if (result.nextStep.signInStep === 'CONFIRM_SIGN_UP') {
          navigation.navigate('ConfirmSignUpScreen', { username });
          return;
        }
        setMessage(`Additional step: ${result.nextStep.signInStep}`);
        return;
      }

      await handleSubmit();
      navigation.replace('Home');

    } catch (e) {
      setMessage(e.message || 'Sign in failed');
    }
  };

  // ADD: Navigate to ForgotPassword screen (prefill username if present)
  const handleForgotPassword = () => {
    const prefill = (username || '').trim();
    navigation.navigate('ForgotPasswordScreen', { username: prefill });
  };

  if (isLoading) {
    return (
      <View style={[mystyles.formCard, { justifyContent: 'center', alignItems: 'center' }]}>
        <Text>Loading...</Text>
      </View>
    );
  }

  return (
    <View style={mystyles.formCard}>
      <View style={mystyles.inputWrapper}>
        <Text style={mystyles.inputLabel}>Please provide your credentials</Text>
        <View style={mystyles.inputRow}>
          <Text style={mystyles.inputIcon}>👤</Text>
          <TextInput
            style={mystyles.input}
            placeholder="User Id"
            value={username}
            onChangeText={setUsername}
            autoCapitalize="none"
            autoCorrect={false}
            placeholderTextColor="#9CA3AF"
            selectionColor="#0EA5E9"
          />
        </View>
      </View>

      <View style={mystyles.inputWrapper}>

        <View style={mystyles.inputRow}>
          <Text style={mystyles.inputIcon}>🔒</Text>
          <TextInput
            style={mystyles.input}
            placeholder="Password"
            value={password}
            onChangeText={setPassword}
            secureTextEntry
            autoCapitalize="none"
            autoCorrect={false}
            placeholderTextColor="#9CA3AF"
            selectionColor="#0EA5E9"
            textContentType="password"
          />
        </View>
      </View>

      <View style={mystyles.inputWrapper}>

        <View style={mystyles.inputRow}>
          <Text style={mystyles.inputIcon}>Current zipcode</Text>
          <TextInput
            style={mystyles.input}
            placeholder="My current ZIP code"
            value={zipcode}
            onChangeText={(text) => setZipcode(String(text).replace(/[^0-9]/g, '').slice(0, 5))}
            keyboardType="number-pad"
            textContentType="postalCode"
            maxLength={5}
            placeholderTextColor="#9CA3AF"
            selectionColor="#0EA5E9"
          />
        </View>
      </View>

      <Pressable
        onPress={handleSignIn}
        accessibilityRole="button"
        accessibilityLabel="Sign in"
        style={({ pressed }) => [mystyles.primaryBtn, pressed && mystyles.primaryBtnPressed]}
        hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
      >
        <Text style={mystyles.primaryBtnText}>Sign in</Text>
      </Pressable>

      {/* ADD: "Forgot password?" link */}
      <Pressable
        onPress={handleForgotPassword}
        accessibilityRole="link"
        hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
        style={({ pressed }) => [{ paddingVertical: 8, alignSelf: 'flex-start' }, pressed && { opacity: 0.6 }]}
      >
        <Text style={{ color: '#1e88e5', fontWeight: '600' }}>Forgot password?</Text>
      </Pressable>

      {/* ADD: "Back to Sign up" link (bottom) */}
      <Pressable
        onPress={() => navigation.navigate('SignUpScreen')}
        accessibilityRole="link"
        hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
        style={({ pressed }) => [
          { paddingVertical: 8, alignSelf: 'flex-start' },
          pressed && { opacity: 0.6 },
        ]}
      >
        <Text style={{ color: '#1e88e5', fontWeight: '600' }}>Back to Sign up</Text>
      </Pressable>

      {message ? <Text style={mystyles.message}>{message}</Text> : null}
    </View>
  );
}
